import { useState } from 'react';
import { httpService } from '../../../Helpers/Fetcher/axios';
import Toaster from '../../Toaster/Toaster';

const Toast = Toaster();
interface IResponse<T> {
  success: boolean;
  data: T;
  message?: string;
}

const UpdateDataApi = <T,>(url: string) => {
  const [response, setResponse] = useState<T | null>(null);
  const [success, setSuccess] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const updateData = async (payload: any) => {
    setError(null);

    try {
      setLoading(true);
      const res: IResponse<T> = await httpService.patch({ url, data: payload });
      if (res.success) {
        setSuccess(true);
        setResponse(res.data);
        Toast.fire({
          icon: 'success',
          title: `Successfully Updated!`,
        });
      } else {
        setSuccess(false);
        setError('something went wrong');
      }
    } catch (err: any) {
      setSuccess(false);
      setError(err?.response?.data?.message);
      Toast.fire({
        icon: 'error',
        title: err?.response?.data?.message || 'Something went wrong',
      });
    } finally {
      setLoading(false);
    }
  };

  return { response, loading, error, updateData, success, setSuccess };
};

export default UpdateDataApi;
